import { batchActions } from 'redux-batched-actions';
import { updatePageDetails, changePage } from 'state/actions/app_status';
import { displayMessage } from 'state/actions/message_status';


export const displayErrorMessage = text => displayMessage({
        type: 'notification',
        close: false,
        variant: 'attention',
        time: 5000,
        align: 'top-left',
        icon: 'bullhorn',
        title: 'Urgent',
        text,
        handleClick: null
    });

export const displaySuccessMessage = text => displayMessage({
    type: 'notification',
    close: false,
    variant: 'secondary',
    time: 5000,
    align: 'top-left',
    icon: 'check-circle',
    title: 'Success',
    text,
    handleClick: null
});


export const displayPrimaryMessage = text => displayMessage({
    type: 'notification',
    close: true,
    variant: 'primary',
    time: 5000,
    align: 'top-left',
    icon: 'bullhorn',
    title: 'New Update',
    text,
    handleClick: null
});

export const sendMessage = text => displayMessage({
    type: 'toaster',
    close: true,
    variant: 'primary',
    time: 5000,
    align: 'bottom-right',
    message: text,
    handleClick: null
});

export const sendErrorMessage = text => displayMessage({
    type: 'toaster',
    close: true,
    variant: 'attention',
    time: 5000,
    align: 'bottom-right',
    message: text,
    handleClick: null
});

//-------------------- Status Code Error Actions --------------------//

const moveToPage = (location) => dispatch => {
    dispatch(updatePageDetails(location));
    dispatch(changePage(location));
};

export const failedApiCallReroute = (statusCode) => {
    switch (statusCode) {
        case 404:
            return moveToPage('error/404');
        case 403:
            return moveToPage('error/403');
        default:
            return moveToPage('error/500');
    }
};